/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import wysiwyg from "vue-wysiwyg";
import VS2 from 'vue-script2'
import Vuex from 'vuex'
import axios from 'axios';
import Editor from 'vue-editor-js/src/index'
import VueTimeline from "@growthbunker/vuetimeline";

import SuiVue from 'semantic-ui-vue';
import 'semantic-ui-css/semantic.min.css';
import 'vue-kanban/src/assets/kanban.css';
import vueKanban from 'vue-kanban';
import VueSuggestion from 'vue-suggestion';
import VueInstagram from 'vue-instagram';

export const eventBus = new Vue();

import '../vue.custom.config';
import SimpleFlowchart from 'vue-simple-flowchart';
import 'vue-simple-flowchart/dist/vue-flowchart.css';
import ErrorService from "./models/ErrorService.js";
import Buefy from 'buefy';
import LoadScript from "vue-plugin-load-script";

import storePlugin from './storePlugin'
import UserModel from "./models/UserModel";
import "leaflet/dist/leaflet.css";
import { Icon } from 'leaflet';


Vue.use(Argon);
Vue.use(VS2);
Vue.use(SuiVue);
Vue.use(wysiwyg, {});
Vue.use(Vuex);
Vue.use(storePlugin);
Vue.use(Buefy);
Vue.use(Editor);
Vue.use(vueKanban);
Vue.use(VueSuggestion);
//Vue.config.errorHandler = (error) => ErrorService.onError(error);
Vue.use(VueTimeline, {
	// Specify the theme to use: dark or light (dark by default).
	theme: "light",
});


console.log('api_url');



const startPromise = new  Promise((resolve, reject) => {

	  UserModel.check().then(function(result){
		resolve(result);
	});



});

router.beforeEach(async (to, from, next) => {

	// startPromise.then(function(result_login){
	// 	if(to.matched.some(record => record.meta.need_login)) {
	// 		//console.log('result login');
	// 		//console.log(result_login);
	// 		if(result_login){
	// 			next();
	// 		}else {
	// 			//console.log('result false');
	// 			next({
	// 				path: '/',
	// 				query: { nextUrl: to.fullPath }
	// 			});
	// 		}
	//
	//
	// 	}else {
	// 		next();
	// 	}
	// });

		if(to.matched.some(record => record.meta.need_login)) {
			//console.log('result login');
			//console.log(result_login);
			var result_login=await UserModel.check();
			console.log('is guard result login');
			console.log(result_login);
			if(result_login){
				next();
			}else {
				//console.log('result false');
				next({
					path: '/',
					query: { nextUrl: to.fullPath }
				});
			}





		}else {
			next();
		}


});


Vue.mixin({
	methods: {
		Logout() {
			var app = this;
		    UserModel.logout();

			window.location.href = "/";
		}


	}
});


const vm = new Vue({
	router,
	beforeCreate() { this.$store.commit('INITIALISATION_STORE') },
	render: h => h(App)
}).$mount("#app");

export {vm}